export enum AlertSeverityLevel {
    Watch = 1,
    Action = 2,
    Alert = 3,
    Critical = 4,
}

export const UNKNOWN_ALERT_SEVERITY = -1;

export enum AlertEventState {
    Active = 1,
    Resolved = 2,
    Acknowledged = 3,
    Escalated = 4
}

export enum AlertDeliveryStatus {
    Pending = 0,
    Sent = 1,
    Delivered = 2,
    Failed = 3,
    Opened = 4,
}

export enum AlertDeliveryChannel {
    Email = 0,
    SMS = 1,
    InApp = 2,
    Push = 3,
}

export enum AlertEventTransitionSource {
    InAppUi = 0,
    ApiCall = 1,
    EmailLink = 2,
    SmsDeepLink = 3,
    AutoEscalation = 4,
    AutoResolve = 5,
}

export function alertSeverityLabel(severity: AlertSeverityLevel | number | null | undefined): string {
    switch (severity) {
        case AlertSeverityLevel.Critical:
            return 'Critical';
        case AlertSeverityLevel.Alert:
            return 'Alert';
        case AlertSeverityLevel.Action:
            return 'Action';
        case AlertSeverityLevel.Watch:
            return 'Watch';
        default:
            return 'Unknown';
    }
}
